import type { ButtonProps } from "@highoutput/ui-components";
import { Button, Text, useDisclosure } from "@highoutput/ui-components";
import { PopupModal } from "react-calendly";

type RenderButton = (context: { isOpen?: boolean; onOpen(): void; onClose(): void }) => JSX.Element;

/* 💡 Styles can be modified under "config/themes/styles.ts" */
export default function Calendly({
  children,
  renderButton,
  textBtn,
  ...props
}: ButtonProps & { renderButton?: RenderButton } & { textBtn?: Boolean }) {
  const { isOpen, onOpen, onClose } = useDisclosure({
    onClose() {
      document.body.style.overflow = "unset";
    },
    onOpen() {
      document.body.style.overflow = "hidden";
    },
  });

  return (
    <>
      {renderButton && <>{renderButton({ isOpen, onClose, onOpen })}</>}
      {!renderButton && !textBtn && (
        <Button
          aria-label="Schedule a call"
          data-href={process.env.NEXT_PUBLIC_CALENDLY_URL}
          onClick={onOpen}
          {...props}
        >
          {children}
        </Button>
      )}
      {textBtn && (
        <Text as="u" textDecoration={props.textDecoration} onClick={onOpen}>
          {children}
        </Text>
      )}

      {typeof document !== "undefined" && (
        <PopupModal
          iframeTitle="Schedule a session"
          url={process.env.NEXT_PUBLIC_CALENDLY_URL}
          rootElement={document.documentElement}
          open={isOpen}
          onModalClose={onClose}
          pageSettings={{
            hideEventTypeDetails: false,
            hideLandingPageDetails: true,
          }}
        />
      )}
    </>
  );
}
